const O = {
  "CROPPER_MODAL.HEADER.TITLE": "Cropper",
  "CROPPER_MODAL.INSPECTOR.TITLE": "Crop image",
  "CROPPER_MODAL.INSPECTOR.PATH_LABEL": "Shape",
  "CROPPER_MODAL.INSPECTOR.PATH_CUSTOM": "Custom",
  "CROPPER_MODAL.INSPECTOR.PATH_SQUARE": "Square (1:1)",
  "CROPPER_MODAL.INSPECTOR.PATH_PORTRAIT": "Portrait (3:4)",
  "CROPPER_MODAL.INSPECTOR.PATH_LANDSCAPE": "Landscape (4:3)",
  "CROPPER_MODAL.INSPECTOR.PATH_WIDE": "Wide (16:9)",
  "CROPPER_MODAL.INSPECTOR.PATH_COVER": "Cover (16:10)",
  "CROPPER_MODAL.INSPECTOR.PATH_CIRCLE": "Circle",
  "CROPPER_MODAL.INSPECTOR.DIMENSIONS_LABEL": "Dimensions",
  "CROPPER_MODAL.DIMENSIONS.WIDTH.NUMBER_VALIDATION": "Width must be a number",
  "CROPPER_MODAL.DIMENSIONS.WIDTH.MIN_VALIDATION": "Width must be greater than {value}px",
  "CROPPER_MODAL.DIMENSIONS.WIDTH.MAX_VALIDATION": "Width must be less than {value}px",
  "CROPPER_MODAL.DIMENSIONS.HEIGHT.NUMBER_VALIDATION": "Height must be a number",
  "CROPPER_MODAL.DIMENSIONS.HEIGHT.MIN_VALIDATION": "Height must be greater than {value}px",
  "CROPPER_MODAL.DIMENSIONS.HEIGHT.MAX_VALIDATION": "Height must be less than {value}px",
  "CROPPER_MODAL.ACTIONS.CANCEL": "Cancel",
  "CROPPER_MODAL.ACTIONS.SAVE": "Save"
};
export {
  O as en_US
};
